export const AnalyticsSections = {
  LANDING_PAGE: 'Landing Page',
  LOGIN_PAGE: 'Login Page',
  RECOVER_PASSWORD: 'Recover Password',
  CREATE_PASSWORD: 'Create Password',
  SUBSCRIPTION_PAGE: 'Subscription Page',
  PERSONAL_INFORMATION_PAGE: 'Personal Information Page',
  CHOOSE_YOUR_PATH: 'Choose Your Path',
  BUSINESS_INFORMATION: 'Business Information',
  EMAIL_VERIFICATION: 'Email Verification',
  BUSINESS_INFORMATION_2: 'Business Information 2',
  BANKING_INFORMATION: 'Banking Information',
  SOFTWARE_PLANS: 'Software Plans',
  SOFTWARE_FEATURES: 'Software Features',
  NRS_PAY_PLANS: 'NRS Pay Plans',
  EQUIPMENT_SERVICES: 'Equipment Services',
  SUMMARY: 'Summary',
  PAYMENT_PLANS: 'Payment Plans',
  AGREEMENTS: 'Agreements',
  SUCCESS_PAGE: 'Success Page',
  WIZARD: 'Wizard',
  ACCOUNT_PORTAL: 'Account Portal',
  ERROR_PAGE: 'Error Page',
} as const;

export const AnalyticsEvents = {
  // Landing Page Events
  LANDING_PAGE_VIEWED: 'Landing Page Viewed',
  SIGN_UP_CLICKED: 'Signup Clicked',
  LOGIN_CLICKED: 'Sign-in Clicked',

  // Login Page Events
  LOGIN_PAGE_VIEWED: 'Login Page Viewed',
  LOGIN_ATTEMPT: 'Login Attempt',
  LOGIN_SUCCESS: 'Login Success',
  LOGIN_FAILURE: 'Login Failure',

  // Subscription Page Events
  SUBSCRIPTION_PAGE_VIEWED: 'Subscription Page Viewed',
  SUBSCRIPTION_BUNDLE_SELECTED: 'Hardware Bundle Selected',
  SUBSCRIPTION_FORM_VALIDATION_ERROR: 'Subscription Form Validation Error',
  SUBSCRIPTION_FORM_SUBMITTED: 'Subscription Form Submitted',

  // Personal Information Page Events
  PERSONAL_INFO_PAGE_VIEWED: 'Personal Info Page Viewed',
  PERSONAL_INFO_FORM_SUBMITTED: 'Personal Info Form Submitted',
  PERSONAL_INFO_FORM_ERROR: 'Personal Info Form Error',

  // Choose Your Path Events
  CHOOSE_YOUR_PATH_PAGE_VIEWED: 'Choose Your Path Page Viewed',
  CHOOSE_YOUR_PATH_REGULAR_SIGNUP_CLICKED: 'Choose Your Path Regular Signup Clicked',
  CHOOSE_YOUR_PATH_WIZARD_CLICKED: 'Choose Your Path Wizard Clicked',
  CHOOSE_YOUR_PATH_BACK_CLICKED: 'Choose Your Path Back Clicked',

  // Business Information Events
  BUSINESS_INFO_PAGE_VIEWED: 'Business Info Page Viewed',
  BUSINESS_INFO_FORM_SUBMITTED: 'Business Info Form Submitted',
  BUSINESS_INFO_FORM_ERROR: 'Business Info Form Error',

  // Email Verification Events
  EMAIL_VERIFICATION_PAGE_VIEWED: 'Email Verification Page Viewed',
  EMAIL_VERIFIED_SUCCESSFULLY: 'Email Verified Successfully',
  EMAIL_VERIFICATION_FAILED: 'Email Verification Failed',
  RESEND_VERIFICATION_EMAIL: 'Resend Verification Email',

  // Business Information 2 Events
  BUSINESS_INFO_2_PAGE_VIEWED: 'Business Info 2 Page Viewed',
  BUSINESS_INFO_2_FORM_ERROR: 'Business Info 2 Form Error',
  BUSINESS_INFO_2_FORM_SUBMITTED: 'Business Info 2 Form Submitted',
  BUSINESS_INFO_2_EWIC_AND_EBT_INFO: 'Business Info 2 eWIC and EBT Info',

  // Banking Information Events
  BANK_PAGE_VIEWED: 'Bank Page Viewed',
  BANK_DETAILS_POPUP_ERROR: 'Bank Details popup error',
  BANK_INFORMATION_SUBMITTED: 'Bank Information Submitted',
  BANK_DETAILS_POLLING_ERROR: 'Bank Details Polling Error',

  // Software Plans Events
  SOFTWARE_PLANS_PAGE_VIEWED: 'Software Plans Page Viewed',
  SOFTWARE_PLANS_SUBMITTED: 'Software Plans Submitted',

  // Software Features Events
  SOFTWARE_FEATURES_PAGE_VIEWED: 'Software Features Page Viewed',
  SOFTWARE_FEATURES_SUBMITTED: 'Software Features Submitted',

  // NRS Pay Plans Events
  NRSPAY_PLANS_PAGE_VIEWED: 'NRSPAY Plans Page Viewed',
  NRSPAY_PLAN_SUBMITTED: 'NRSPAY Plan Submitted',

  // Equipment Services Events
  EQUIPMENT_SERVICES_PAGE_VIEWED: 'Equipment Services Page Viewed',
  EQUIPMENT_PAGE_SUBMITTED: 'Equipment Page Submitted',

  // Summary Events
  SUMMARY_PAGE_VIEWED: 'Summary Page Viewed',

  // Payment Plans Events
  PAYMENT_PLANS_PAGE_VIEWED: 'Payment Plans Page Viewed',
  PAYMENT_METHOD_SELECTED: 'Payment Method Selected',
  PAYMENT_DETAILS_SUBMITTED: 'Payment Details Submitted',
  PAYMENT_PLANS_HOME_ADDRESS_SAVED: 'Payment Plans Home Address Saved',
  PAYMENT_PLANS_HOME_ADDRESS_FAILED: 'Payment Plans Home Address Failed',

  // Agreements Events
  AGREEMENTS_PAGE_VIEWED: 'Agreements Page Viewed',
  POS_CONTRACT_SIGNED: 'POS Contract Signed',
  NRS_PAY_CONTRACT_SIGNED: 'NRSPAY Contract Signed',
  AGREEMENT_PAGE_ON_COMPLETE: 'Agreement completed',

  // Success Page Events
  SUCCESS_PAGE_VIEWED: 'Success Page Viewed',
  // Wizard Events
  WIZARD_STARTED: 'Wizard Started',
  BEST_FIT_PAGE_VIEWED: 'Best Fit Page Viewed',
  WIZARD_COMPLETED: 'Wizard Completed',

  // Account Portal Events
  ACCOUNT_PORTAL_VIEWED: 'Account Portal Viewed',
  ORDER_SUMMARY_VIEWED: 'Order Summary Viewed',
  FAILED_PAYMENTS_VIEWED: 'Failed Payments Viewed',
  NEXT_BILLINGS_VIEWED: 'Next Billings Viewed',
  CUSTOMER_STORES_VIEWED: 'Customer Stores Viewed',
} as const;

export type AnalyticsSectionType = typeof AnalyticsSections[keyof typeof AnalyticsSections];
export type AnalyticsEventType = typeof AnalyticsEvents[keyof typeof AnalyticsEvents];

export const AnalyticsProviders = {
  MIXPANEL: 'MixPanel',
  GOOGLE_ANALYTICS: 'Google Analytics',
} as const;

export type AnalyticsProviderType = typeof AnalyticsProviders[keyof typeof AnalyticsProviders];
